import styled from 'styled-components';
import Theme from '../../theme';

export const BlogEmbeddedAssetCaption = styled.div`
  justify-content: center;
  text-align: center;
  letter-spacing: 0.1rem;
  font-size: ${Theme.fontSizes[0]}px;
  line-height: ${Theme.lineHeights.heading[1]}px;
  font-family: ${Theme.fonts.heading};
  margin: 0 auto;
  margin-top: ${Theme.space[3]}px;
  display: flex;
  flex-direction: row;
  width: 80%;
  @media screen and (min-width: 840px) {
    > * {
      margin-right: ${Theme.space[4]}px;
    }
  }
`;
